import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ffb6516a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./assets/index.less?vue&type=style&index=0&id=ffb6516a&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb6516a",
  null
  
)

export default component.exports